var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{staticClass:"btn-ims--cta",style:({
        backgroundColor: ("#" + (_vm.portalBranding.portalAccentColor)),
        borderColor: ("#" + (_vm.portalBranding.portalAccentColor)),
    }),attrs:{"title":_vm.title,"label":_vm.label,"size":_vm.size,"type":_vm.type,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }